import classNames from 'classnames'
import { JSX } from 'react'

import { IInputCommonProps } from './models/IInputCommonProps'

import styles from './Label.module.scss'

export interface ILabelProps {
  label?: IInputCommonProps['label']
  startContent?: IInputCommonProps['startContent']
  wrapper?: IInputCommonProps['wrapper']
  dir?: IInputCommonProps['dir']
  value?: string
  focused?: boolean
  customTemplates?: {
    labelRoot?: () => boolean
    labelContent?: () => JSX.Element | boolean
  }
  labelClassName?: string
  labelFieldSetClassName?: string
  rightSpacing?: string
  /**
   * Root test ID. This property is used for automated tests.
   */
  __testId?: string
}

export const Label = ({
  customTemplates,
  label,
  focused,
  startContent,
  wrapper,
  dir,
  value,
  rightSpacing,
  labelClassName,
  labelFieldSetClassName,
  __testId,
}: ILabelProps) => {
  const labelRootTemplate = customTemplates?.labelRoot ? customTemplates.labelRoot() : false
  const labelContentTemplate = customTemplates?.labelContent
    ? customTemplates.labelContent()
    : false

  const labelVisible = labelRootTemplate || !!label

  return (
    <>
      <fieldset
        style={{ paddingRight: rightSpacing }}
        className={classNames(
          styles.fieldset,
          focused ? styles['fieldset--focused'] : '',
          wrapper && styles[`fieldset--${wrapper}`],
          labelFieldSetClassName
        )}
        data-testid={'inputFieldset'}
      >
        {labelVisible ? (
          <legend
            className={classNames(
              styles.legend,
              focused || value || startContent ? styles['legend--focused'] : ''
            )}
          >
            <span className={styles.legend__mask}>
              {!labelContentTemplate ? label : labelContentTemplate}
            </span>
          </legend>
        ) : null}
      </fieldset>
      {labelVisible ? (
        <div
          className={classNames(
            styles.label,
            labelClassName,
            focused || value || startContent ? styles['label--focused'] : '',
            wrapper && styles[`label--${wrapper}`],
            dir ? styles[`label--${dir}`] : ''
          )}
          style={{ right: `${rightSpacing}` }}
          data-testid={'inputLabel'}
        >
          <label data-testid={__testId} className={styles.label__tag}>
            {!labelContentTemplate ? label : labelContentTemplate}
          </label>
        </div>
      ) : null}
    </>
  )
}
